<template>
    <div>
        <component :is="model.headingTag" v-if="model.heading" class="h4">{{ model.heading }}</component>
        <p v-if="model.description" class="preamble">
        {{ model.description }}
        </p>
        <div ref="wasteSearch" class="h6"><label for="wasteSearch">{{ model.langSearchWaste }}</label></div>
        <div class="search-input">
            <div ref="searchStatus" role="status" class="sr-only">{{ searchAriaStatus }}</div>
            <autocomplete
                id="wasteSearch"
                ref="autocomplete"
                :model="query"
                class="col-lg-12 px-0"
                :search="searchSuggestions"
                :placeholder="model.langSearchPlaceholder"
                :aria-label="model.langSearchPlaceholder"
                :get-result-value="getSuggestionText"
                @click="clearField"
                @submit="handleSubmit"
                @blur="handleBlur">
                <template
                    #default="{
                        rootProps,
                        inputProps,
                        inputListeners,
                        resultListProps,
                        resultListListeners,
                        results,
                        resultProps
                    }"
                >
                    <div v-bind="rootProps">
                        <custom-input
                            ref="searchInput"
                            :class="[
                                'autocomplete-input'
                            ]"
                            style="padding: 24px 24px 24px 48px"
                            v-bind="inputProps"
                            v-on="inputListeners"
                        ></custom-input>
                        <ul v-bind="resultListProps" role="region" aria-live="polite" aria-atomic="true" v-on="resultListListeners">
                            <li class="suggestions-text">{{ model.suggestionsLabel }}:</li>
                            <li
                                v-for="(result, index) in results"
                                :key="resultProps[index].id"
                                v-bind="resultProps[index]"
                                >
                                {{ result.text }}
                            </li>
                        </ul>
                    </div>
                </template>
            </autocomplete>
            <button class="button" type="submit" :aria-label="model.searchButtonAriaLabel" @click="submit">{{ model.searchButtonLabel }}</button>
        </div>
        <div class="h6 my-3">
        {{ model.langOr }}
        </div>
        <div class="col-auto px-0">
            <a class="button" :href="model.categoriesPageUrl">
                {{ model.langBrowseCategory }}<span class="ml-2 arrow-icon" aria-hidden="true">
                    <svg class="icon icon-hsy-icon-arrow-right-bold"><use xlink:href="#icon-hsy-icon-arrow-right-bold"></use></svg>
                </span>
            </a>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import customInput from './custom-input.vue';
    export default {
        components: {
            "custom-input": customInput
        },
        props: {
            model: {
                type: Object,
                required: true
            }
        },
        data: () => {
            return {
                query: '',
                searchAriaStatus: ''
            }
        },
        mounted() {
            this.$refs.wasteSearch.focus();
        },
        methods: {
            clearField() {
                this.$refs.autocomplete.setValue('');
                this.searchAriaStatus = '';
            },
            handleBlur() {
                this.searchAriaStatus = '';
            },
            searchSuggestions(query) {
                this.query = query;
                const url = `${this.model.autoSuggestionsUrl}?query=${encodeURI(this.query)}`
                return new Promise(resolve => {
                    if (this.query.length < 1) {
                        return resolve([])
                    }

                    fetch(url)
                        .then(response => response.json())
                        .then(data => {
                            resolve(data.hits)
                            this.searchAriaStatus = this.model.langSearchAriaStatus;
                        })
                })
            },
            getSuggestionText(suggestion) {
                return (suggestion || {}).text;
            },
            handleSubmit(selectedSuggestion) {
                if (selectedSuggestion) {
                    this.handleHitClick(selectedSuggestion);
                }
                else {
                    window.open(`${this.model.searchResultsPageUrl}?query=` + encodeURI(this.query), "_self");
                }
            },
            submit() {
                window.open(`${this.model.searchResultsPageUrl}?query=` + encodeURI(this.query), "_self");
            },
            handleHitClick(hit) {
                if (hit.trackUrl) {
                    axios.get(hit.trackUrl).then(() => {
                        hit.trackUrl = null;
                        if (hit.url) window.location.href = hit.url;
                    })
                }
                else {
                    if (hit.url) window.location.href = hit.url;
                }
            }
        }
    }
</script>